import Component from 'can/component/component';
import _ from 'lodash';
import template from './vc-featured.stache';

import 'components/history-experience/player-course-collections/player-course-collections';

Component.extend({
    tag: 'vc-featured',
    template: template,
    viewModel: {
        cards: {
            type: '*',
        },
    },
});
